import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { MyTimesheetEntriesProps } from 'services/myTimesheetEntries/types';

// Global Components
import SemiBold from 'components/SemiBold';

// Global Selectors
import { makeSelectMyTimesheetIsSaved } from 'services/myTimesheetEntries/selectors';

type OwnProps = MyTimesheetEntriesProps;

interface ConnectedProps {
    isSaved: boolean;
}

type Props = OwnProps & ConnectedProps;

export class MyTimesheetEntryIsSaved extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { isSaved } = this.props;
        if (!isSaved) {
            return <SemiBold warning>SAVED OFFLINE ONLY</SemiBold>;
        }
        return <SemiBold positive>SAVED ONLINE</SemiBold>;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isSaved: makeSelectMyTimesheetIsSaved()
});

export default connect(mapStateToProps)(MyTimesheetEntryIsSaved);
